<div class="flex w-full flex-row gap-16">
    <ui-input-text
        class="flex-1"
        [disabled]="disabled()"
        [value]="range().from?.toString()"
        (valueChange)="$event ? setFrom(+$event) : null"
        label="ab"
    />
    <ui-input-text
        class="flex-1"
        [value]="range().to?.toString()"
        [disabled]="disabled()"
        (valueChange)="$event ? setTo(+$event) : null"
        label="bis"
    />
</div>
